import React from 'react';
import './Footer.scss';
import { NavLink } from 'react-router-dom';

const Footer = () => {
  return (
    <div className='footer_main_section'>
      <div className='container'>
        <div className='footer_top_section'>
          <div className='footer_menu_section logo_text'>
            <div className='footer_logo'>
              <img src="/images/byp_logo.png" alt="" />
              <h3>A dynamic app that helps you manage your money between paychecks</h3>
              <p>info@bypapp.com</p>
              <div className='social_icon_list'>
                <a href="https://www.facebook.com/BYPapp/" target="_blank" rel="noopener noreferrer" className='social_btn'>
                  <img src="/images/facebook.svg" alt="Facebook" />
                </a>
                <a href="https://www.instagram.com/TheBYPapp/" target="_blank" rel="noopener noreferrer" className='social_btn'>
                  <img src="/images/instagram.svg" alt="Instagram" />
                </a>
                <a href="https://www.tiktok.com/@BYPapp" target="_blank" rel="noopener noreferrer" className='social_btn'>
                  <img src="/images/tiktok.svg" alt="TikTok" />
                </a>
                <a href="https://www.linkedin.com/company/budget-your-paycheck/" target="_blank" rel="noopener noreferrer" className='social_btn'>
                  <img src="/images/linkedin.svg" alt="LinkedIn" />
                </a>
                <a href="https://www.youtube.com/@TheBYPapp" target="_blank" rel="noopener noreferrer" className='social_btn'>
                  <img src="/images/youtube.svg" alt="YouTube" />
                </a>
              </div>
            </div>
          </div>

          <div className='footer_menu_section'>
            <div className='footer_logo'>
              <h2>Useful Links</h2>
              <div className='footer_menu_link'>
                <a href='#home' className="footer_menu">Home</a>
                {/* <a href='#about-us' className="footer_menu">About Us</a> */}
                <a href='#key-features' className="footer_menu">Key Features</a>
                <a href='#contact-us' className="footer_menu">Contact us</a>
              </div>
            </div>
          </div>
          <div className='footer_menu_section'>
            <div className='footer_logo'>
              <h2>Help & Support</h2>
              <div className='footer_menu_link'>
                <NavLink to="/help-and-support" className="footer_menu">Help & Support</NavLink>
                <NavLink to="/terms-and-conditions" className="footer_menu">Terms & Conditions</NavLink>
                <NavLink to="/privacy-policy" className="footer_menu">Privacy Policy</NavLink>
              </div>
            </div>
          </div>
          <div className='footer_menu_section'>
            <div className='footer_logo'>
              <h2>Let’s Try Out</h2>
              <div className='download_button_play'>
                <a className='app_store_btn' href='https://apps.apple.com/app/id6738954470' target='_blank' rel='noopener noreferrer'>
                  <img src="/images/app_store_blur.svg" alt="Download on the App Store" />
                </a>
                <a className='app_store_btn' href='https://play.google.com/store/apps/details?id=com.budget_bible.android&pcampaignid=web_share' target='_blank' rel='noopener noreferrer'>
                  <img src="/images/google_play_blur.svg" alt="Get it on Google Play" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='copy_right_section'>
        <div className='container'>
          Copyright © - 2026 BYP. All Rights Reserved.
        </div>
      </div>
    </div>
  )
}

export default Footer
